import * as React from "react";
import { forwardRef } from "react";
const SvgOfflineFill = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "currentColor", viewBox: "0 0 18 18", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M.751 9a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Zm4.5 0c0 .415.336.75.75.75h6a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0-.75.75Z" }));
const ForwardRef = forwardRef(SvgOfflineFill);
export default ForwardRef;
